"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const contexts_1 = require("@App/contexts");
require("./index.scss");
const GroupedTable_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/GroupedPublishersTable/GroupedTable"));
const common_1 = require("@Const/common");
const overclaim_1 = require("@App/api/routes/overclaim");
const document_upload_table_cells_1 = require("@App/helpers/overclaim/document-upload-table-cells");
const GroupedDocumentUploadTable = (0, react_1.forwardRef)(({ onAddDescriptionToDocumentClicked }, ref) => {
    const { overclaimViewStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const downloadDocumentClicked = (rightsHolderId, overclaimId, overclaimHeaderId) => __awaiter(void 0, void 0, void 0, function* () {
        if (rightsHolderId) {
            const response = yield (0, overclaim_1.getOverclaimUploadDocumentFor)(rightsHolderId, overclaimId, overclaimHeaderId);
            window.open(response.data.downloadLink, '_blank');
        }
    });
    const uploadedDocumentToTableRow = (uploadedDocument, topMemberIpId, overclaimId) => ({
        name: undefined,
        removeCellIdentifier: uploadedDocument.name,
        removable: false,
        cells: (0, document_upload_table_cells_1.generateDocumentUploadTableCells)({
            uploadedDocument: uploadedDocument,
            onAddDescriptionToDocumentClicked: onAddDescriptionToDocumentClicked,
            onDownloadDocumentClicked: (memberUploadId) => {
                downloadDocumentClicked(topMemberIpId, overclaimId, memberUploadId).then();
            },
        }),
    });
    const publisherTableInfo = (0, react_1.useMemo)(() => Object.entries(overclaimViewStore.overclaimDocuments).map(([topMemberIpId, overclaimUploadedDocuments]) => {
        var _a, _b;
        const memberIpId = Number.parseInt(topMemberIpId, 10);
        const publisherName = (_b = (_a = overclaimViewStore.overclaimViewItem) === null || _a === void 0 ? void 0 : _a.originalPublishers.find((value) => value.topMemberIpId === memberIpId)) === null || _b === void 0 ? void 0 : _b.topMemberName;
        return overclaimUploadedDocuments
            .filter((doc) => {
            if (memberIpId !== rightsholderStore.currentRightsholderId) {
                return doc.status === 'ACCEPTED';
            }
            return true;
        })
            .map((doc) => {
            var _a;
            return uploadedDocumentToTableRow(doc, memberIpId, ((_a = overclaimViewStore.overclaimViewItem) === null || _a === void 0 ? void 0 : _a.overclaimHeaderId) || 0);
        })
            .map((row) => ({
            groupedBy: publisherName,
            groupedValue: undefined,
            headerRow: undefined,
            rows: [row],
        }));
    }), [overclaimViewStore.overclaimDocuments, rightsholderStore.currentRightsholderId]);
    return (react_1.default.createElement(react_1.default.Fragment, null, publisherTableInfo.map((publisher, index) => (react_1.default.createElement(GroupedTable_1.default, { key: index, tableInfo: publisher, icon: common_1.ICONS.account, rowsAreValid: () => true, ref: ref })))));
});
GroupedDocumentUploadTable.displayName = 'GroupedDocumentUploadTable';
exports.default = (0, mobx_react_1.observer)(GroupedDocumentUploadTable);
